// Vendors
require('../vendors/bower_components/legitripple/js/ripple');

require('../vendors/bower_components/corejs-typeahead/dist/typeahead.jquery');
require('../vendors/bower_components/air-datepicker/dist/js/datepicker');
require('../vendors/bower_components/matchHeight/dist/jquery.matchHeight');
require('../vendors/bower_components/jGrowl/jquery.jgrowl');
require('../vendors/bower_components/lightgallery/dist/js/lightgallery-all');
require('../vendors/bower_components/tooltipster/dist/js/tooltipster.bundle');
require('../vendors/bower_components/mousetrap/mousetrap');
require('../vendors/bower_components/jquery-mousewheel/jquery.mousewheel');
require('../vendors/bower_components/handlebars/handlebars');
require('../vendors/bower_components/fullcalendar/dist/fullcalendar');
require('../vendors/bower_components/waypoints/lib/noframework.waypoints');
require('../vendors/bower_components/waypoints/lib/shortcuts/sticky');
import MediumEditor from '../vendors/bower_components/medium-editor/dist/js/medium-editor';

// Special imports
import Dropzone from '../vendors/bower_components/dropzone/dist/dropzone';
import smoothScroll from '../vendors/bower_components/smooth-scroll/dist/js/smooth-scroll';
import autosize from '../vendors/bower_components/autosize/dist/autosize';
import ClipboardJS from '../vendors/bower_components/clipboard/dist/clipboard';
import _ from '../vendors/bower_components/underscore/underscore-min';
import Handlebars from '../vendors/bower_components/handlebars/handlebars';
import Bloodhound from '../vendors/bloodhound/bloodhound.min';

window.dragula = require('../vendors/bower_components/dragula.js/dist/dragula');
window.Dropzone = Dropzone;
window.smoothScroll = smoothScroll;
window.autosize = autosize;
window.ClipboardJS = ClipboardJS;
window._ = _;
window.Handlebars = Handlebars;
window.Bloodhound = Bloodhound;
window.MediumEditor = MediumEditor;

// SUPER SPECIAL, INSTALL MOMENT IN YOUR OWN PROJECT, APPO DOESNT PROVIDE IT THROUGH WEBPACK
// noinspection NpmUsedModulesInstalled
import moment from 'moment';
//
window.moment = moment;

// Import all modules in the Lib folder
const requireTest = require.context('./lib', false, /\.js$/);
requireTest.keys().forEach(requireTest);
